import {
  Directive,
  ElementRef,
  Renderer2,
  Input,
  OnInit,
  HostListener,
  AfterViewInit,
} from '@angular/core';

@Directive({
  selector: '[appImagePlaceholder]',
})
export class PlaceHolderImageLoadingDirective implements OnInit, AfterViewInit {
  @Input() appImagePlaceholder: string;
  @Input() widthP: string;
  @Input() pclass: string;
  isLoaded = false;
  divItem: any;
  divPicture: any;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnInit() {
    this.divItem = this.renderer.createElement('div');
    this.renderer.setAttribute(this.divItem, 'class', 'ph-item p-0 h-100');

    this.divPicture = this.renderer.createElement('div');

    this.renderer.setAttribute(
      this.divPicture,
      'class',
      'ph-picture b-0 h-100'
    );

    if (this.widthP) {
      this.renderer.setStyle(
        this.divPicture,
        `width`,
        `${this.widthP} !important`
      );
    }
    if (this.pclass) {
      this.renderer.addClass(this.divItem, this.pclass);
    }
    this.renderer.appendChild(this.divItem, this.divPicture);

    this.renderer.insertBefore(
      this.el.nativeElement.parentElement,
      this.divItem,
      this.renderer.nextSibling(this.el.nativeElement)
    );

    this.el.nativeElement.style.display = this.isLoaded ? 'block' : 'none';
  }

  @HostListener('load', ['$event'])
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onLoaded(_value: any) {
    this.isLoaded = true;
    this.el.nativeElement.style.display = 'block';
    this.removePlaceholder();
  }

  removePlaceholder(): void {
    this.renderer.removeChild(this.divItem, this.divPicture);
    this.renderer.removeChild(document.body, this.divItem);
    this.divPicture = null;
    this.divItem = null;
  }

  ngAfterViewInit(): void {
    this.el.nativeElement.src = this.appImagePlaceholder;
  }
}
